const OurPartnerSection = ({ data, partnerHead }) => {

  // Ensure data is an array and has items
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <section className="partner_section">
        <div className="partner_container">
          <h2 className="logo_heading">{partnerHead?.our_partners_section_heading}</h2>
          <div className="logo_slider_wrapper">
            <div className='loader'><img src="assets/img/LoaderSky47.gif" alt='loader image' /></div>
          </div>
        </div>
      </section>
    );
  }
  
  return (
    <section className="partner_section">
      <div className="partner_container">
        <h2 className="logo_heading">{partnerHead?.our_partners_section_heading}</h2>
        <div className="logo_slider_wrapper">
          {/* FIX: Use stable unique keys based on item.id instead of index */}
          <div className="logo_slider">
            {data.length === 0 ?
              <div className='loader'>
                <img
                  src="assets/img/LoaderSky47.gif"
                  alt='Loading partners'
                  width="100"
                  height="100"
                  loading="lazy"
                />
              </div>
            : data.map((item) => (
              <img
                key={`slider1-${item.id || item.title.rendered}`}
                src={item._embedded?.['wp:featuredmedia']?.[0]?.source_url}
                className={`logo_img ${item.title.rendered.replace(/\s+/g, '-')}`}
                alt={item.title.rendered}
                width="150"
                height="80"
                loading="lazy"
              />
            ))}
          </div>
          <div className="logo_slider">
            {data.length === 0 ?
              <div className='loader'>
                <img
                  src="assets/img/LoaderSky47.gif"
                  alt='Loading partners'
                  width="100"
                  height="100"
                  loading="lazy"
                />
              </div>
            : data.map((item) => (
              <img
                key={`slider2-${item.id || item.title.rendered}`}
                src={item._embedded?.['wp:featuredmedia']?.[0]?.source_url}
                className={`logo_img ${item.title.rendered.replace(/\s+/g, '-')}`}
                alt={item.title.rendered}
                width="150"
                height="80"
                loading="lazy"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurPartnerSection;